import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClipping, ILabelArticle } from 'src/models/onlineMedia';

export interface IOfmComparison {
  selectedClipping: Array<IClipping>;
  selectedLabel: Array<ILabelArticle>;
}

const initialState: IOfmComparison = {
  selectedClipping: [],
  selectedLabel: []
};

export const ofmComparison = createSlice({
  name: 'ofmComparison',
  initialState,
  reducers: {
    reducerUpdateDataSelectedLabel: (
      state: IOfmComparison,
      action: PayloadAction<Array<ILabelArticle>>
    ) => {
      state.selectedLabel = action.payload;
    },
    reducerUpdateDataSelectedClipping: (
      state: IOfmComparison,
      action: PayloadAction<Array<IClipping>>
    ) => {
      state.selectedClipping = action.payload;
    }
  }
});

export const {
  reducerUpdateDataSelectedLabel,
  reducerUpdateDataSelectedClipping
} = ofmComparison.actions;

export default ofmComparison.reducer;
